import * as Yup from 'yup';
import { debugLog } from './common/miscUtils';

export type AssertSchemaMatchesModel<TModel, TSchemaType extends TModel> = TSchemaType;

export const validateContract = <TSchema extends Yup.AnySchema>(
  schema: TSchema,
  payload: unknown,
  contractName: string
): boolean => {
  try {
    schema.validateSync(payload, { abortEarly: false, strict: true });
    return true;
  } catch (error) {
    const messages = error instanceof Yup.ValidationError ? error.errors.join('; ') : String(error);
    debugLog({ level: 'ERROR', message: `[DataContract:${contractName}] ${messages}` });
    return false;
  }
};
